<template>
    <div class="grid">
        <div class="col-12">
            <div v-if="!isEdit" class="card">
                <h3>Employee Assessement</h3>
                <div class="formgroup-inline">
                    <div class="field">
                        <label for="dd" class="font-medium">Input Employee Name</label>
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true" v-model="selectedAutoValue"
                            :suggestions="autoFilteredValue" @complete="searchCandidate($event)" @item-select="selectCandidate()" field="name" :disabled="isSelected"
                            :class="{ 'p-invalid': submitted && !selectedAutoValue }"/>
                        <small class="p-invalid" v-if="submitted && !selectedAutoValue">
                            Assessor is required.
                        </small>
                        <Button label="Remove" class="p-button-primary mr-2 ml-2" @click="clearSelected" :disabled="!isSelected"/>
                    </div>
                </div>
            </div>
            <div class="card">
                <h4>Next Detail</h4>
                <TabView v-model:activeIndex="active">
                    <TabPanel header="Candidate Information" :disabled="!isSelected">
                        <div class="p-fluid">
                            <AssessementPersonalInfoVue :submitted="submitted" :model="employee" :disabled="!isSelected" ref="personal"></AssessementPersonalInfoVue>
                            <Button @click="savePersonalInfo" id="button1" label="Next" />
                        </div>
                    </TabPanel>
                    <TabPanel header="Setup Placement" :disabled="!isSelected">
                        <div class="p-fluid">
                            <AssessementScoreVue :submitted="submitted" ref="assessement"></AssessementScoreVue>
                            <Button @click="saveAssessementScore" label="Next"/>
                        </div>
                    </TabPanel>
                    <TabPanel header="Training" :disabled="!isSelected">
                        <div class="p-fluid">
                            <AssessementDescriptionVue :submitted="submitted" ref="description"></AssessementDescriptionVue>
                            <Button label="Save" @click="store" :disabled="!isSelected"/>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import AutoComplete from 'primevue/autocomplete';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AppLayout from '../../Layouts/AppLayout';
import axios from "axios";
import AssessementPersonalInfoVue from "./Components/AssessementPersonalInfo.vue";
import AssessementScoreVue from "./Components/AssessementScore.vue";
import AssessementDescriptionVue from "./Components/AssessementDescription.vue";

export default {
    layout: AppLayout,
    components: {
        Dropdown, Calendar, InputText, AutoComplete, Button, TabView, TabPanel, AssessementPersonalInfoVue, AssessementScoreVue, AssessementDescriptionVue
    },
    props: ['employee'],
    data() {
        return {
            assessement: this.$page.props.assessement ?? [],
            submitted: false,
            employee: [],
            autoFilteredValue: [],
            selectedAutoValue: '',
            isSelected: false,
            active: 0,
            isEdit: false,
        }
    },
    computed: {

    },
    mounted() {
        if(this.$page.props.assessement){
            this.selectedAutoValue = this.$page.props.assessement.employee;
            this.selectCandidate(this.$page.props.assessement.employee_id);
            this.isEdit = true;
        }
    },
    methods: {
        searchCandidate(event) {
				setTimeout(() => {
					if (!event.query.trim().length) {
                        axios.get(`${this.$page.props.appUrl}api/employees`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
					else {
                        let filterValue = event.query.toLowerCase();
                        axios.get(`${this.$page.props.appUrl}api/employees?search=${filterValue}`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
				}, 250);
			},
        selectCandidate(){
            this.isSelected = true;
            axios.get(`${this.$page.props.appUrl}api/employees/${this.selectedAutoValue.id}`)
                .then((data) => {
                    this.employee = data.data.data;
                });
        },
        clearSelected(){
            this.selectedAutoValue = '';
            this.isSelected = false;
        },
        savePersonalInfo(){
            this.submitted = true;
            let personal = this.$refs.personal.form;
            let validated = true;

            if(Object.keys(personal).length === 0){
                validated = false;
            }

            for (const record in personal) {
                if (!personal[record]) {
                    validated = false;
                }
            }

            if(validated){
                this.submitted = false;
                this.active = 1;
            }
        },
        saveAssessementScore(){
            this.submitted = true;
            let assessement = this.$refs.assessement.form;
            let validated = true;

            if(Object.keys(assessement).length === 0){
                validated = false;
            }

            if(validated){
                this.submitted = false;
                this.active = 2;
            }
        },
        store(){
            let personal = this.$refs.personal.form;
            let assessement = this.$refs.assessement.assessements;
            let description = this.$refs.description.form;
            let form_assessement = this.$refs.assessement.form;

            let new_assessement = [];
            const keys = Object.keys(assessement);

            keys.forEach((key, index) => {
                var obj = {};
                obj[assessement[index]['field_name']] = assessement[index]['score'];
                new_assessement.push(obj);
            });

            let judul = {...new_assessement};
            let payload = {employee_id: this.employee.id ,...personal, ...form_assessement, ...description, assessements: judul};

            if(this.isEdit){
                axios.put(`${this.$page.props.appUrl}api/employee-assessements/${this.$page.props.assessement.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Training Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Training",
                        detail: error,
                        life: 3000,
                    });
                })
            }
            else{
                axios.post(`${this.$page.props.appUrl}api/employee-assessements`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Training Created",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Created Training",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
    }
}
</script>
